var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldenGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2230_16892)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3142 10.875H6.41399C6.63031 7.7638 7.71234 5.24067 8.78532 3.45237C8.96264 3.15684 9.14005 2.88075 9.3138 2.62473C5.58379 3.69145 2.76813 6.92402 2.3142 10.875ZM6.414 13.125H2.3142C2.76813 17.076 5.58387 20.3087 9.31394 21.3753C9.14016 21.1193 8.96268 20.8431 8.78532 20.5475C7.71236 18.7592 6.63034 16.2362 6.414 13.125ZM8.67039 13.125H15.3295C15.1188 15.7282 14.2064 17.8547 13.2853 19.3899C12.8259 20.1555 12.3675 20.7686 12 21.2133C11.6325 20.7686 11.1741 20.1555 10.7147 19.3899C9.79359 17.8547 8.88119 15.7282 8.67039 13.125ZM15.3297 10.875H8.67037C8.88116 8.27169 9.79357 6.14515 10.7147 4.60998C11.1741 3.84436 11.6325 3.23123 12 2.78655C12.3675 3.23123 12.8259 3.84436 13.2853 4.60998C14.2064 6.14515 15.1188 8.27169 15.3297 10.875ZM17.586 13.125C17.3697 16.2362 16.2876 18.7592 15.2146 20.5475C15.0373 20.8431 14.8598 21.1193 14.6861 21.3753C18.4161 20.3087 21.2319 17.076 21.6858 13.125H17.586ZM21.6858 10.875H17.586C17.3697 7.7638 16.2876 5.24067 15.2146 3.45237C15.0373 3.15684 14.8599 2.88075 14.6862 2.62471C18.4163 3.69144 21.2319 6.92402 21.6858 10.875ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6275 5.37258 24 12 24C18.6275 24 24 18.6275 24 12C24 5.37258 18.6275 0 12 0Z",
    fill: "#EE811A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2230_16892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenGlobe);
export default __webpack_public_path__ + "static/media/golden-globe.f08e22158add690c84113e7a9c29f5b5.svg";
export { ForwardRef as ReactComponent };